import { GridFilterTypes } from "../../../grid/AgGridManager";
import { FieldSchema } from "../../../Schema";

/**
 * The maturity stages a V&V device moves through.
 *
 * Grid-scoped for the same reason as {@link vnvStatusFilterValues}: the value is owned by the
 * V&V Linked Instance, so the list describes the column's filter rather than an input.
 */
export const vnvMaturityClassificationFilterValues = ["Not assigned", "Functional Model", "Prototype", "Pilot", "Series"];

/**
 * V&V maturity classification of a device held in the V&V Linked Instance.
 *
 * Header reads "V&V Classification" — the shorter form the Equipment List design uses — while
 * the field keeps the model's full name.
 */
export const vnvMaturityClassification: FieldSchema = {
  name: "vnvMaturityClassification",
  grid: {
    displayed: true,
    defaultVisible: false,
    order: 83,
    label: "V&V Classification",
    filter: GridFilterTypes.SET,
    filterValues: vnvMaturityClassificationFilterValues,
    sortable: true,
  },
};
